import React from 'react';
import { Box } from '@mui/material';

interface DateAndTimeInfoProps {
  label: string;
  highlighted?: boolean;
  isDifferentDate?: boolean; // Seçili tarihten farklı tarih mi?
}

const DateAndTimeInfo: React.FC<DateAndTimeInfoProps> = ({ label, highlighted, isDifferentDate }) => {
  // Label'ı parse et: "23 ARALIK  11:00" -> tarih ve saat kısmını ayır
  const parts = label.split('  '); // Çift boşluk ile ayır
  const datePart = parts[0]?.trim() || ''; // "23 ARALIK"
  const timePart = parts[1]?.trim() || ''; // "11:00"
  
  return (
    <Box
      sx={{
        width: '100%',
        height: '41px',
        position: 'relative',
        backgroundColor: highlighted ? '#2f73fe' : '#fff',
        border: '1px solid',
        borderColor: highlighted ? '#2f73fe' : '#f0f0f0',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0px 16px',
        textAlign: 'left',
        fontSize: '14px',
        color: highlighted ? '#ffffff' : '#545a66',
        fontFamily: 'Plus Jakarta Sans',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          letterSpacing: '-0.02em',
          textTransform: 'uppercase',
          whiteSpace: 'pre-wrap',
        }}
      >
        {isDifferentDate ? (
          <>
            <Box component="span" sx={{ color: '#ff0004' }}>
              {datePart}
            </Box>
            {timePart && (
              <Box component="span" sx={{ color: '#ff0004' }}>
                {'  '}
                {timePart}
              </Box>
            )}
          </>
        ) : (
          label
        )}
      </Box>
    </Box>
  );
};

export default DateAndTimeInfo;

